import { IPulseHighlight, PulseIntent } from './pulse-highlight'

/**
 * A pulse target that forwards to several rings at once.
 *
 * `FieldShellProps.pulseRef` takes a single handle, which assumes the thing
 * worth lighting up is one control. A field whose body is a *row* of tiles has
 * no such single thing: pulsing the container rings the whole row — including
 * the slots that are already satisfied — when only the outstanding ones are
 * the problem.
 *
 * The returned object is `{current}`-shaped so it can be handed straight to
 * `pulseRef`, and it resolves its targets lazily on every pulse, so a row that
 * has re-rendered since mount still rings the tiles currently on screen.
 */
export function createPulseFanout(
  getTargets: () => Array<IPulseHighlight | null | undefined>,
): { current: IPulseHighlight } {
  return {
    current: {
      pulse(intent?: PulseIntent) {
        getTargets().forEach((target) => target?.pulse(intent))
      },
    },
  }
}
